import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IClientDataConsentDto } from 'src/app/contracts';
import { Api } from 'src/app/core/common/api';
import { IApiOptions } from 'src/app/core/contracts';
import { UI } from 'src/app/core/helpers/ui';

@Injectable({ providedIn: 'root' })
export class DataPrivacyData {
  private api = inject(Api);
  private ui = inject(UI);

  getDataConsent(options?: IApiOptions): Observable<IClientDataConsentDto> {
    return this.api.get('dataprivacy/consent', options);
  }
  withdrawConsent() {
    return this.api.post('dataprivacy/withdraw-consent');
  }
  submitConsent(data: IClientDataConsentDto) {
    return this.api.post('dataprivacy/consent', data);
  }
  editConsent(data: IClientDataConsentDto) {
    return this.api.update('dataprivacy/consent', data);
  }
}
